import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Menu, MenuItem, TextField, Tooltip } from '@mui/material';

const AppSheetOrderItemsSendMenu = ({
  anchorEl,
  row,
  onClose,
  onSendToStaging,
  onSendWithNotes,
  onSendToVmt,
  onEditAndSendVmt,
  vmtDisabled,
  vmtTooltip,
  notesModal,
  setNotesModal,
  itemLabel = 'order item',
}) => {
  const lowerItemLabel = String(itemLabel || 'order item').toLowerCase();
  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableScrollLock
      >
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            onSendToStaging(row, '', event);
            onClose();
          }}
        >
          Send to staging
        </MenuItem>
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            onSendWithNotes(row);
          }}
        >
          Send with notes
        </MenuItem>
        <Tooltip title={vmtTooltip} placement="right">
          <span>
            <MenuItem
              disabled={vmtDisabled}
              onClick={(event) => {
                event.stopPropagation();
                onClose();
                onSendToVmt(row);
              }}
            >
              Send to VMT
            </MenuItem>
          </span>
        </Tooltip>
        <MenuItem
          data-testid="appsheet-edit-send-vmt-menu-item"
          onClick={(event) => {
            event.stopPropagation();
            onClose();
            // The table adds an internal MRT row id for rendering. Keep the
            // editor draft sourced from the actual AppSheet payload instead of
            // leaking that display-only key into the handoff.
            const sourceRow = { ...(row || {}) };
            delete sourceRow.__rowId;
            onEditAndSendVmt?.(sourceRow);
          }}
        >
          Edit &amp; Send VMT
        </MenuItem>
      </Menu>

      <Dialog open={notesModal.open} onClose={() => setNotesModal({ open: false, row: null, notes: '' })} maxWidth="sm" fullWidth>
        <DialogTitle>{`Stage ${lowerItemLabel} with notes`}</DialogTitle>
        <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Notes (for your reference only)"
            value={notesModal.notes}
            onChange={(event) => setNotesModal((prev) => ({ ...prev, notes: event.target.value }))}
            multiline
            minRows={4}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNotesModal({ open: false, row: null, notes: '' })}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => {
              if (!notesModal.row) return;
              onSendToStaging(notesModal.row, notesModal.notes);
              setNotesModal({ open: false, row: null, notes: '' });
            }}
            disabled={!notesModal.notes?.trim()}
          >
            {`Stage ${lowerItemLabel} with notes`}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AppSheetOrderItemsSendMenu;
